import http from "@/components/services/http-common";

export function getWhiteList() {
  return http.get("enrollments/white-list").then(r => r.data)
}